var namespace = 'ol-ctx-menu';
export default {
  namespace: namespace,
  container: "".concat(namespace, "-container"),
  separator: "".concat(namespace, "-separator"),
  submenu: "".concat(namespace, "-submenu"),
  hidden: "".concat(namespace, "-hidden"),
  icon: "".concat(namespace, "-icon"),
  zoomIn: "".concat(namespace, "-zoom-in"),
  zoomOut: "".concat(namespace, "-zoom-out"),
  unselectable: 'ol-unselectable'
};